import { css } from "@emotion/css";
import type { ColumnsType } from "antd/es/table";

/** Dense table rows for agent container detail pages */
export const agentCompactTableClass = css`
  .ant-table-thead > tr > th {
    padding: 6px 8px !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    line-height: 1.35 !important;
  }

  .ant-table-tbody > tr > td {
    padding: 4px 8px !important;
    font-size: 13px !important;
    line-height: 1.4 !important;
  }

  .ant-table-tbody > tr > td .ant-tag {
    font-size: 12px;
    line-height: 18px;
    margin: 0;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

/** Full-width table with equal column distribution (use with tableLayout="fixed") */
export const agentCompactEvenSpreadClass = css`
  .ant-table,
  table {
    width: 100% !important;
    table-layout: fixed !important;
  }

  .ant-table-thead > tr > th {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: break-word;
    line-height: 1.25;
  }

  .ant-table-tbody > tr > td {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .ant-table-tbody > tr > td a {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const agentCompactTableEvenClass = `${agentCompactTableClass} ${agentCompactEvenSpreadClass}`;

export const agentCompactCardStyles = {
  body: { padding: "8px 12px" },
  header: { minHeight: 40 },
};

/** Assign percentage widths so columns fill the table evenly (optional weights). */
export function spreadColumnsEvenly<T>(
  columns: ColumnsType<T>,
  weights?: number[]
): ColumnsType<T> {
  const totalWeight =
    weights?.reduce((sum, w) => sum + w, 0) ??
    columns.length;

  return columns.map((col, index) => {
    const weight = weights?.[index] ?? 1;
    const width = `${((weight / totalWeight) * 100).toFixed(2)}%`;

    return {
      ...col,
      width,
      ellipsis: col.ellipsis === false ? false : col.ellipsis ?? true,
    };
  });
}
